import axios from "axios";
import { API_PATHS } from "../utils/constants/api.constants";

const popularCache = {
  commercial: null,
  household: null,
  event: null,
};

function unwrapTypeaheadResponse(response) {
  return response?.data?.data || response?.data || {};
}

export async function fetchCuisineTypeahead(type, q = "") {
  const params = new URLSearchParams({ type });
  if (q) params.set("q", q);
  const response = await axios.get(`${API_PATHS.cuisineTypeaheadV2}?${params.toString()}`);
  return unwrapTypeaheadResponse(response);
}

export async function getPopularCuisineSuggestions(type) {
  if (popularCache[type]) {
    return popularCache[type];
  }
  const result = await fetchCuisineTypeahead(type, "");
  if (result.mode === "popular_suggestions" && Array.isArray(result.data)) {
    popularCache[type] = result.data;
    return result.data;
  }
  return Array.isArray(result.data) ? result.data : [];
}

export async function searchCuisineSuggestions(type, query) {
  const q = String(query || "").trim();
  if (!q) {
    return getPopularCuisineSuggestions(type);
  }
  const result = await fetchCuisineTypeahead(type, q);
  return Array.isArray(result.data) ? result.data : [];
}

export function clearCuisinePopularCache(type) {
  if (type) {
    delete popularCache[type];
    return;
  }
  Object.keys(popularCache).forEach((key) => {
    delete popularCache[key];
  });
}

export function toCuisineSelection(item) {
  if (!item) return null;
  if (typeof item === "string") {
    return { cuisineName: item, slug: "" };
  }
  return {
    cuisineName: item.cuisineName || item.name || "",
    slug: item.slug || "",
  };
}

export function normalizeCuisineSelection(items = []) {
  return items
    .map(toCuisineSelection)
    .filter((item) => item?.cuisineName);
}

export function cuisineNamesFromSelection(items = []) {
  return normalizeCuisineSelection(items).map((item) => item.cuisineName);
}

export function extractCuisinePayload(items = []) {
  const normalized = normalizeCuisineSelection(items);
  return {
    cuisines: normalized.map((item) => item.cuisineName),
    cuisineSlugs: normalized.map((item) => item.slug).filter(Boolean),
  };
}

export function cuisinesFromLegacyNames(names = [], slugs = []) {
  return (names || []).map((name, index) => ({
    cuisineName: name,
    slug: slugs?.[index] || "",
  }));
}
